import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { PagareResumen } from 'app/models/pagare.model';

@Injectable({
    providedIn: 'root'
})
export class ReporteForm24Service {

    private readonly APIurl = environment.apis + "/reporte";
    constructor(
        private http: HttpClient
    ) {

    }

   
    getPagaresResumen(fecha_inicial: string, fecha_final: string) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };

        let qs = {
            fecha_inicial: fecha_inicial != null ? fecha_inicial : '',
            fecha_final: fecha_final != null ? fecha_final : '',
        };

        let qs2 = Object.keys(qs)
            .reduce(
                (acc, elem) => {
                    acc.push(elem + '=' + qs[elem]);
                    return acc;
                },
                ['?']
            )
            .join('&');
        return this.http.get<any>(this.APIurl + '/form24-pagare-resumen'+ qs2, options);
    }

    getParametros() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<any>(this.APIurl + '/form24-parametros', options);
    }
}
